import React, {useState} from "react";

import List from "components/Values/List"

import { useLocalStorage } from "utils/storage";

const ValuesSelectCard = ({
    onClick,
    onCancel
}) => {
    const [values] = useLocalStorage('values', []);

    return (
        <div className="card card-paddings container-height">

            <div className="card-header card-header-paddings no-background no-border">
                <div className="p-2">
                    <h3>Values</h3>
                </div>
            </div>

            <div className="card-body overflow-auto p-0">
                <List 
                    items={values}
                    onClickHandler={onClick}
                />
            </div>

            <div className="card-footer card-footer-paddings border-top no-background">
                <div className="d-flex">
                    <button 
                        type="button" 
                        className="btn btn-secondary ms-auto" 
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ValuesSelectCard;